export default function () {
  return {
    sessionId: Date.now(),
    questions: {},
    submitState: false
  }
}
